import { hiprint } from"vue-plugin-hiprint";
export const TableProvider = function (options) {
  console.log(options);
  var addElementTypes = function (context) {
    // context.removePrintElementTypes("tableProviderModule");
    context.addPrintElementTypes("tableProviderModule", [
      new hiprint.PrintElementTypeGroup("常规", [
        // 注意这里，使用了传入的 options.config
        {
          tid: "tableProviderModule.table",
          field: "table",
          title: "默认单据",
          groupFields: ["name"],
          type: "table",
          columns: [[
            {
              title: "行号",
              field: "index"
            },
            {
              title: "品名规格",
              field: "name"
            },
            {
              title: "单位",
              field: "model"
            },
            {
              title: "数量",
              field: "amount"
            },
            {
              title: "单价",
              field: "price"
            },
            {
              title: "金额",
              field: "total_price"
            },
            {
              title: "享受折扣",
              field: "discost"
            },
            {
              title: "折后金额",
              field: "discost_price"
            },
            {
              title: "备注",
              field: "remark"
            },
          ]],
          editable: true,
          columnDisplayEditable: true,//列显示是否能编辑
          columnDisplayIndexEditable: true,//列顺序显示是否能编辑
          columnTitleEditable: true,//列标题是否能编辑
          columnResizable: true, //列宽是否能调整
          columnAlignEditable: true,//列对齐是否调整
          isEnableEditField: true, //编辑字段
          isEnableContextMenu: true, //开启右键菜单 默认true
          isEnableInsertRow: true, //插入行
          isEnableDeleteRow: true, //删除行
          isEnableInsertColumn: true, //插入列
          isEnableDeleteColumn: true, //删除列
          isEnableMergeCell: true, //合并单元格
        }
      ])
    ])
  };
  return {
    addElementTypes: addElementTypes,
  };
};